(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/balance-bar/assets/javascripts/balance-bar.js') >= 0) return;  svs.modules.push('/components/lb-ui/balance-bar/assets/javascripts/balance-bar.js'); 'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

svs.lbUi = svs.lbUi || {};

var BalanceBar = function () {
  function BalanceBar() {
    var _this = this;

    _classCallCheck(this, BalanceBar);

    var $body = $('body');
    var $topContentWrapper = svs.components.header.getFixedTopContentWrapper();
    var $corporateInfoWrapper = $('.js-corporate-info-bar');
    var corporateInformationPreventAnimationClass = 'corporate-info-animation-disabled';

    if (svs.core.detect.feature('ft-dialog-for-accountbalance')) {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.core.deviceSession.get('hadShownAccountBalanceDialog', 'balance-bar', function (res) {
          if (res === undefined || res === false) {
            svs.core.deviceSession.set('hadShownAccountBalanceDialog', 'balance-bar', true);

            _this.showDialog();
          }
        });
      }
    }

    this.showAccountBalance = false;

    if (svs.core.detect.breakpoint.greaterThan('md')) {
      $body.addClass(corporateInformationPreventAnimationClass);
    } else {
      svs.core.detect.breakpoint.on('change', function () {
        if (svs.core.detect.breakpoint.greaterThan('md')) {
          $body.addClass(corporateInformationPreventAnimationClass);
        }
      });
    }

    var breakPointListener = function breakPointListener() {
      if (svs.core.detect.breakpoint.lessThan('md')) {
        $corporateInfoWrapper.addClass('js-fixed-top-content');
        $topContentWrapper.removeClass('js-fixed-top-content');
        svs.components.header.setFixedTopContentWrapper($corporateInfoWrapper);
      } else {
        $corporateInfoWrapper.removeClass('js-fixed-top-content');
        $topContentWrapper.addClass('js-fixed-top-content');
        svs.components.header.setFixedTopContentWrapper($topContentWrapper);
      }
    };

    svs.core.detect.breakpoint.on('change', breakPointListener);
    breakPointListener();

    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      var rendered = svs.lb_ui && svs.lb_ui.balance_bar && svs.lb_ui.balance_bar.data.account_balance_rendered;
      this.$sessionTimeContainer = $('.js-session-time-header');
      this.$accountBalanceContainer = $('.js-balance-toggle');
      this.$accountBalanceContent = $('.js-balance-content');
      this.renderLoggedInTime(svs.components.session_time.get());
      this.noAccountBalance = Boolean(svs.core.template.getConfig().noAccountBalance);
      this.hideBalanceBarInXsSm = Boolean(svs.core.template.getConfig().hideBalanceBarInXsSm);
      svs.events.subscribe('/components/session_time/sessionTimeM', function (sessionTime) {
        return _this.renderLoggedInTime(sessionTime);
      });
      $('.js-gaming-test-link').on('click', function (e) {
        e.preventDefault();
        svs.utils.url.navigate("".concat(svs.utils.urlMapping.get('mygamingSelfTest'), "?returnUrl=").concat(encodeURIComponent(svs.utils.url.currentPathEncodedParams()), "#selftestStart"));
      });
      $('.js-corporate-info-pause24-link').on('click', function (e) {
        return _this.onPause24Click(e);
      });
      this.$accountBalanceContainer.on('click', function (e) {
        return _this.toggleAccountBalance(e);
      });
      svs.components.account_balance.on('change', function (balance) {
        if (_this.showAccountBalance && !_this.noAccountBalance) {
          _this.renderAccountBalance(balance);
        }
      });
      svs.core.template.on('configUpdate', function (e) {
        var propIndex = e.changed.indexOf('noAccountBalance');

        if (~propIndex) {
          _this.noAccountBalance = Boolean(e.config.noAccountBalance);

          if (_this.noAccountBalance && _this.showAccountBalance) {
            _this.renderAccountBalance();
          } else if (!_this.noAccountBalance && _this.showAccountBalance) {
            svs.components.account_balance.get(true, _this.renderAccountBalance, _this);
          }
        }

        propIndex = e.changed.indexOf('hideBalanceBarInXsSm');

        if (~propIndex) {
          if (_this.hideBalanceBarInXsSm !== Boolean(e.config.hideBalanceBarInXsSm)) {
            _this.hideBalanceBarInXsSm = !_this.hideBalanceBarInXsSm;

            if (_this.hideBalanceBarInXsSm) {
              $body.addClass('hide-balance-bar');
            } else {
              $body.removeClass('hide-balance-bar');
            }

            svs.components.header.updateCachedHeights();
          }
        }

        propIndex = e.changed.indexOf('hideBalanceBar');

        if (~propIndex || ~e.changed.indexOf('hideMenu')) {
          var shouldHideBalanceBar = e.config.hideBalanceBar || e.config.hideMenu;

          if (_this.hideBalanceBar !== shouldHideBalanceBar) {
            _this.hideBalanceBar = !_this.hideBalanceBar;

            if (_this.hideBalanceBar) {
              $body.addClass('hide-balance-bar-all-over');
            } else {
              $body.removeClass('hide-balance-bar-all-over');
            }

            svs.components.header.updateCachedHeights();
          }
        }
      });
      svs.core.userSession.get('showAccountBalance', function (error, data) {
        _this.showAccountBalance = Boolean(data);

        if (!rendered) {
          if (_this.showAccountBalance) {
            svs.components.account_balance.get(true, _this.renderAccountBalance, _this);
          } else {
            _this.renderAccountBalance();
          }
        }
      });
    }
  }

  _createClass(BalanceBar, [{
    key: "showDialog",
    value: function showDialog() {
      var dialog = new svs.components.dialog.Contextual({
        branding: svs.components.dialog.branding.SPORT,
        attachTo: document.querySelector('.balance-bar-account'),
        zIndex: 1069,
        title: ' ',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: 'Här kan du se ditt saldo och sätta in pengar.'
        }]
      });
      svs.components.dialog.api.add(dialog);
    }
  }, {
    key: "renderLoggedInTime",
    value: function renderLoggedInTime() {
      var timeInMinutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var timeToDisplay;

      if (timeInMinutes < 60) {
        timeToDisplay = "".concat(timeInMinutes, " min");
      } else if (timeInMinutes < 24 * 60) {
        timeToDisplay = "".concat(Math.floor(timeInMinutes / 60), " tim ").concat(timeInMinutes % 60, " min");
      } else if (timeInMinutes < 48 * 60) {
        timeToDisplay = '1 dag';
      } else {
        timeToDisplay = "".concat(Math.ceil(timeInMinutes / (24 * 60)), " dagar");
      }

      this.$sessionTimeContainer.html(timeToDisplay);
    }
  }, {
    key: "onPause24Click",
    value: function onPause24Click(e) {
      e.preventDefault();

      if (svs.accountservices && svs.accountservices.pause24) {
        svs.accountservices.pause24.show();
      } else {
        var loader = new svs.components.Loader();
        loader.show(300, 'inverted');
        svs.core.module.load('/cl/accountservices/pause24', null, function (error) {
          loader.hide();

          if (error && error.statusText === 'error') {
            svs.core.module.load('/cl/components/dialog', null, function () {
              svs.components.dialog.api.add(new svs.components.dialog.Confirm({
                actions: [{
                  title: 'Ok'
                }],
                area: svs.components.dialog.area.POPUP,
                branding: svs.components.dialog.branding.SPORT,
                message: [{
                  text: 'För tillfället upplever vi tekniska problem. Prova igen om en stund.'
                }],
                title: 'Något gick visst fel',
                type: svs.components.dialog.type.ERROR
              }));
            });
          } else {
            svs.accountservices.pause24.show();
          }
        }, false);
      }
    }
  }, {
    key: "toggleAccountBalance",
    value: function toggleAccountBalance(e) {
      var _this2 = this;

      if (svs.core.template.getConfig().noAccountBalance) {
        var dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1100,
          title: ' ',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: 'Eftersom ditt saldo kontinuerligt visas i spelläget går det inte att visa saldot här.'
          }]
        });
        svs.components.dialog.api.add(dialog);
        e.stopPropagation();
      } else if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        this.showAccountBalance = !this.showAccountBalance;
        svs.core.userSession.set('showAccountBalance', this.showAccountBalance, function () {
          if (_this2.showAccountBalance) {
            svs.components.account_balance.get(true, _this2.renderAccountBalance, _this2);
          } else {
            _this2.renderAccountBalance();
          }
        });
      } else {
        this.renderAccountBalance();
      }
    }
  }, {
    key: "renderAccountBalance",
    value: function renderAccountBalance(balance) {
      if (balance === undefined) {
        this.$accountBalanceContent.html('Visa saldo');
      } else {
        this.$accountBalanceContent.html("".concat(svs.utils.format.Currency(balance), " kr"));
      }
    }
  }]);

  return BalanceBar;
}();

svs.lbUi.balance_bar = new BalanceBar();
 })(window);